import {RadialText} from "../components/RadialText";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {TweenParticleEmitter} from "../utils/TweenParticleEmitter";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {KitchenDramaSushiManiaTextStyles} from "../config/KitchenDramaSushiManiaTextStyles";
import {KitchenDramaSushiManiaSound} from "../sound/KitchenDramaSushiManiaSound";
import {gsap, TimelineLite, TweenLite} from "gsap";
import {PropertyNode} from "pixi-particles";

/**
 * Class description
 *
 * Created: 2017-01-24
 * @author jonas
 */
export class KitchenDramaBigWinDisplay extends PIXI.Container implements StageLayer{

    static BANNER_BG:string = "checkerTile";
    static BW_NEXTLVL:string = "bwNextLevel";
    static BW_INTRO:string = "bwIntro";

    static PARTICLE_1:string = "slice/M1_slice1_above";
    static PARTICLE_2:string = "slice/M1_slice2_above";
    static PARTICLE_3:string = "slice/M1_slice3_above";
    static PARTICLE_4:string = "slice/M1_slice1_behind";
    static PARTICLE_5:string = "slice/M2_slice1_behind";
    static PARTICLE_6:string = "slice/M2_slice2_behind";
    static PARTICLE_7:string = "slice/M2_slice3_above";
    static PARTICLE_8:string = "slice/M2_slice3_behind";
    static PARTICLE_9:string = "slice/M3_slice1_above";
    static PARTICLE_10:string = "slice/M3_slice1_behind";
    static PARTICLE_11:string = "slice/M3_slice2_behind";
    static PARTICLE_12:string = "slice/M3_slice3_above";
    static PARTICLE_13:string = "slice/M4_slice2_above";
    static PARTICLE_14:string = "slice/M4_slice3_above";
    static PARTICLE_15:string = "slice/M4_slice1_behind";
    static PARTICLE_16:string = "slice/M4_slice3_behind";
    static PARTICLE_17:string = "slice/W2_slice1_behind";
    static PARTICLE_18:string = "slice/W2_slice2_above";
    static PARTICLE_19:string = "slice/W2_slice3_above";
    static PARTICLE_20:string = "slice/W2_slice3_behind";

    private _introMC:TimelineSprite;
    private _nextLevelMC:TimelineSprite;
    private _bannerPattern:PIXI.TilingSprite;
    private _bannerContainer:PIXI.Container;
    private _bannerBg:PIXI.Graphics;
    private _textContainer:PIXI.Container;
    private _bigWinRadialText:RadialText;
    private _megaWinRadialText:RadialText;
    private _superMegaWinRadialText:RadialText;

    private _leftParticleConfig:any = {
        "alpha" : {
            "start" : 1,
            "end" : 1
        },
        "scale" : {
            "start" : 0.5,
            "end" : 0.5,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 1300,
            "end" : 1300,
            "minimumSpeedMultiplier" : 0.8
        },
        "acceleration" : {
            "x" : 0,
            "y" : 1100
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : -75,
            "max" : -80
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : -400,
            "max" : 400
        },
        "lifetime" : {
            "min" : 2,
            "max" : 2
        },
        "blendMode" : "normal",
        "frequency" : 0.001,
        "emitterLifetime" : 0.1,
        "maxParticles" : 15,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : 0,
            "y" : 0,
            "w" : 840,
            "h" : 300
        }
    };
    private _rightParticleConfig:any = {
        "alpha" : {
            "start" : 1,
            "end" : 1
        },
        "scale" : {
            "start" : 0.5,
            "end" : 0.5,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 1300,
            "end" : 1300,
            "minimumSpeedMultiplier" : 0.8
        },
        "acceleration" : {
            "x" : 0,
            "y" : 1100
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : -100,
            "max" : -105
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : -400,
            "max" : 400
        },
        "lifetime" : {
            "min" : 2,
            "max" : 2
        },
        "blendMode" : "normal",
        "frequency" : 0.001,
        "emitterLifetime" : 0.1,
        "maxParticles" : 15,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : 0,
            "y" : 0,
            "w" : -840,
            "h" : 300
        }

    };

    private _particleTextures:PIXI.Texture[];
    private _leftParticles:TweenParticleEmitter[];
    private _rightParticles:TweenParticleEmitter[];
    private _masterTimeline:TimelineLite;
    private _stageWidth:number;
    private _stageHeight:number;
    private _safeAreaWidth:number;

    private _currentLevel:number;
    private currentDisplayAmount:number = 0;
    private _winAmount:PIXI.BitmapText;
    private _amountTextStyle:any;
    private _darkPlate:PIXI.Sprite;

    constructor() {
        super();
        this.name = "KitchenDramaBigWinDisplay"
        this._stageWidth = 720;
        this._stageHeight = 720;
        this._safeAreaWidth = 1680;


        this.initAnimations();

    }


    protected initAnimations():void {
        this._darkPlate = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._darkPlate.tint = PIXI.utils.string2hex("#223747");
        this._darkPlate.alpha = 0.5;
        this._darkPlate.anchor.set(0.5,0.5);
        this._darkPlate.position.set(360,360);
        this.createParticles();
        this.createGraphics();
        this.createTexts();
        this.createWinAmountText();
        this.resetGraphics();


        this.addChild(this._darkPlate);
        this.addChild(this._bannerContainer);
        this.addChild(this._leftParticles[0]);
        this.addChild(this._rightParticles[0]);

        this.addChild(this._rightParticles[1]);
        this.addChild(this._leftParticles[1]);

        this.addChild(this._introMC);
        this.addChild(this._nextLevelMC);
        this.addChild(this._textContainer);

        this.addChild(this._leftParticles[2]);
        this.addChild(this._rightParticles[2]);

        this.addChild(this._winAmount);
        this.onResize();
    }


    public onResize():void {
        this._darkPlate.width = NolimitApplication.screenBounds.width;
        this._darkPlate.height = NolimitApplication.screenBounds.height;
    }

    public hide() {
        this.visible = false;
    }

    public show() {
        this.visible = true;
    }


    private createGraphics() {
        let tmpTexture:PIXI.Texture = ImgLoader.getImgTexture(KitchenDramaBigWinDisplay.BANNER_BG); //Helper.getTexture(GameResources.RESOURCE_KEY_MAIN, KitchenDramaBigWinDisplay.BANNER_BG);
        this._bannerPattern = new PIXI.TilingSprite(tmpTexture, this._safeAreaWidth + 200, 180);
        this._bannerPattern.position.set(0, 8);

        this._bannerBg = new PIXI.Graphics();
        this._bannerBg.beginFill(0x223747, 1);
        this._bannerBg.drawRect(0, 0, this._safeAreaWidth + 200, 195);
        this._bannerBg.endFill();

        this._bannerContainer = new PIXI.Container();
        this._bannerContainer.name = "banner";
        this._bannerContainer.pivot.set(this._bannerBg.width * 0.5, this._bannerBg.height * 0.5);
        this._bannerContainer.position.set(this._stageWidth * 0.5, this._stageHeight * 0.5);
        this._bannerContainer.addChild(this._bannerBg);
        this._bannerContainer.addChild(this._bannerPattern);


        this._introMC = this.createTweenSprites(KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.BW_INTRO));
        this._introMC.position.y += 27;
        this._nextLevelMC = this.createTweenSprites(KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.BW_NEXTLVL));
    }

    private createTexts() {

        let textStyle:PIXI.TextStyle = new PIXI.TextStyle(KitchenDramaSushiManiaTextStyles.BIG_WIN_TEXT);
        this._amountTextStyle = KitchenDramaSushiManiaTextStyles.KOMIKA_BM_MONOSPACED;

        this._textContainer = new PIXI.Container();
        this._textContainer.pivot.set(0, 1000);
        this._textContainer.position.set(this._stageWidth / 2, this._stageHeight / 2 - 74 + 1000);

        this._bigWinRadialText = new RadialText("OH, LALA", 1000, -1, textStyle);
        this._megaWinRadialText = new RadialText("MON DIEUX!", 1000, -1, textStyle);
        this._superMegaWinRadialText = new RadialText("SACRE BLEU!", 1000, -1, textStyle);

        this._textContainer.addChild(this._bigWinRadialText);
        this._textContainer.addChild(this._megaWinRadialText);
        this._textContainer.addChild(this._superMegaWinRadialText);


    }

    private resetGraphics() {
        this.hide();
        this.alpha = 0;


        this.currentDisplayAmount = 0;
        this.updateWinText();
        this._winAmount.alpha = 0;
        this._introMC.hide();
        this._nextLevelMC.hide();
        this._bannerContainer.scale.set(0, 0.02);
        this._bigWinRadialText.position.x = -this._bigWinRadialText.textWidth * 0.5;
        this._bigWinRadialText.anchor.set(0, 0.5);
        this._bigWinRadialText.scale.set(0, 1);
        this._megaWinRadialText.position.x = -this._megaWinRadialText.textWidth * 0.5;
        this._megaWinRadialText.anchor.set(0, 0.5);
        this._megaWinRadialText.scale.set(0, 1);
        this._superMegaWinRadialText.position.x = -this._superMegaWinRadialText.textWidth * 0.5;
        this._superMegaWinRadialText.anchor.set(0, 0.5);
        this._superMegaWinRadialText.scale.set(0, 1);
    }

    public createTweenSprites(textures:PIXI.Texture[]):TimelineSprite {
        let mc:TimelineSprite = new TimelineSprite(textures, 30);
        mc.anchor.set(0.5, 0.5);
        mc.position.set(this._stageWidth * 0.5, this._stageHeight * 0.5);
        mc.visible = false;

        return mc;
    }

    private flipAnchorOnText(text:RadialText) {
        text.position.x = text.textWidth * 0.5;
        text.anchor.set(1, 0.5);
    }

    //----------------------------------------------------------------------------------
    //    EMITTER STUFF
    //----------------------------------------------------------------------------------
    private createParticles() {
        this._particleTextures = [
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_1)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_2)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_3)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_4)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_5)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_6)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_7)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_8)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_9)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_10)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_11)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_12)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_13)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_14)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_15)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_16)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_17)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_18)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_19)[0],
           KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaBigWinDisplay.PARTICLE_20)[0],
        ];


        this._leftParticles = [];
        this._rightParticles = [];

        const pc = [
            "#84c5ff",
            "#c6e5ff",
            "#ffffff",
        ]

        for(let i:number = 0; i < 3; i++) {
            const scale = 0.5 + (0.1 * i);
            this._leftParticles.push(new TweenParticleEmitter(this._particleTextures, this._leftParticleConfig));
            this._leftParticles[i].emitter.updateSpawnPos(0, this._stageHeight);
            this._leftParticles[i].emitter.startScale = PropertyNode.createList({start:scale, end:scale});
            this._leftParticles[i].emitter.startColor = PropertyNode.createList({start:pc[i], end:pc[i]});


            this._rightParticles.push(new TweenParticleEmitter(this._particleTextures, this._rightParticleConfig));
            this._rightParticles[i].emitter.updateSpawnPos(this._stageWidth, this._stageHeight);
            this._rightParticles[i].emitter.startScale =  PropertyNode.createList({start:scale, end:scale});
            this._rightParticles[i].emitter.startColor = PropertyNode.createList({start:pc[i], end:pc[i]});
        }

    }

    stopAnimations() {
        if(this._masterTimeline && this._masterTimeline.isActive()) {
            this._masterTimeline.kill();
        }

        gsap.to(this,{
            duration:0.5,
            alpha : 0,
            ease : "power3.in",
            onComplete : () => this.resetGraphics()
        });
    }


    public getBigWinIntroAnimation():gsap.core.Timeline {
        let tl = gsap.timeline();
        tl.add(()=>this.show());
        tl.add(gsap.to(this, {duration: 0.2, alpha : 1}));
        tl.add(gsap.to(this._bannerContainer.scale, {duration:0.2, x : 1}));
        tl.add(gsap.to(this._bannerContainer.scale, {duration:0.21,x : 1.3, y : 1.3, ease : "power3.out"}));
        tl.add(gsap.to(this._bannerContainer.scale, {duration:0.1,x : 1.0,  y : 1.0, ease : "back.out(3)"}));

        tl.add([
            gsap.to(this._textContainer,  {duration:0.01, alpha : 0}),
            gsap.to(this._textContainer,  {duration:0.01, rotation : -0.06})
        ]);
        return tl;
    }

    public getBigWinAnimationForLevel(level:number, countUpValues:[number, number][]):TimelineLite {
        let tl:TimelineLite = new TimelineLite();
        this._currentLevel = level;
        let durations = {
            "bigWin":[5150, 5100, 4250],
             "ending":500
        };

        tl.add(()=>KitchenDramaSushiMania.soundPlayer.fadeOutMusic(1000));

        if(level == 0) {
            tl.add(this.createLevelOneIn(durations.bigWin[0] / 1000, countUpValues[0], false));
            tl.add(() => this.centerWinText());
        }

        //LEVEL 1
        else if(level == 1) {
            tl.add(this.createLevelOneIn(durations.bigWin[0] / 1000, countUpValues[0], true));
            tl.add(this.createLevelTwoIn(durations.bigWin[1] / 1000, countUpValues[1], false));
        }

        //LEVEL 2
        else if(level == 2) {
            tl.add(this.createLevelOneIn(durations.bigWin[0] / 1000, countUpValues[0], true));
            tl.add(this.createLevelTwoIn(durations.bigWin[1] / 1000, countUpValues[1], true));
            tl.add(this.createLevelThreeIn(durations.bigWin[2] / 1000, countUpValues[2], false));
        }

        return tl;
    }

    public getBigWinEnd(){
        let tl:TimelineLite = new TimelineLite();
        tl.add(() => this.centerWinText());
        tl.add(()=>{
            KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.BIG_WIN_ENDS)
        });
        tl.add(() => this.stopAnimations(), tl.totalDuration() + 1.0);
        tl.add(()=>KitchenDramaSushiMania.soundPlayer.fadeInMusic(1000));
        return tl;
    }

    private createLevelOneIn(countDuration:number, countFromTo:[number, number], transition:boolean):TimelineLite {
        let tl:TimelineLite = new TimelineLite();
        //text
        tl.add([
            () => this._introMC.show(),
            this._introMC.getAnimation(),
            new TweenLite(this._textContainer, 0.1, {delay : 0.1, alpha : 1}),
            new TweenLite(this._textContainer, 0.5, {delay : 0.1, rotation : 0}),
            new TweenLite(this._bigWinRadialText.scale, 0.1, {delay : 0.1, x : 1})
        ]);


        //particles
        tl.add(this.getParticleAnimation(countDuration, 2), 0);

        //counter
        tl.add(gsap.to(this._winAmount, {duration:0.2, alpha : 1}), 0);
        tl.add(gsap.fromTo(this,
            {currentDisplayAmount : countFromTo[0]},
            {duration:countDuration,currentDisplayAmount : countFromTo[1], onUpdate : () => this.updateWinText(), ease : "power2.out"}), 0);
        tl.add(() => this.centerWinText());
        if(transition) {
            let transition:TimelineLite = this.createTransitionOneTwo();
            tl.add(transition, tl.totalDuration() - transition.totalDuration());
        }

        return tl;
    }

    private createTransitionOneTwo():TimelineLite {
        let tl:TimelineLite = new TimelineLite();
        //Text out
        tl.add(() => this.flipAnchorOnText(this._bigWinRadialText));
        tl.add([
            new TweenLite(this._textContainer, 0.5, {rotation : 0.06, ease : "back.in"}),
            new TweenLite(this._textContainer, 0.1, {alpha : 0, delay : 0.4}),
            new TweenLite(this._bigWinRadialText.scale, 0.1, {x : 0, delay : 0.4})
        ]);


        //Reset text continer
        tl.add([
            new TweenLite(this._textContainer, 0.01, {alpha : 0}),
            new TweenLite(this._textContainer, 0.01, {rotation : -0.06})
        ]);

        tl.add([
            this._nextLevelMC.getAnimation([0, 8]),
            new TweenLite(this._bannerContainer.scale, 0.21, {x : 1.3, y : 1.3, ease : "power3.out"}),
            () => this._nextLevelMC.show(),
            () => this._introMC.hide()
        ]);
        return tl;
    }

    private createLevelTwoIn(countDuration:number, countFromTo:[number, number], transition:boolean):TimelineLite {
        let tl:TimelineLite = new TimelineLite();
        tl.add([
            this._nextLevelMC.getAnimation([8, this._nextLevelMC.totalFrames]),
            new TweenLite(this._bannerContainer.scale, 0.1, {x : 1.0, y : 1.0, ease : "back.out(3)"}),
            new TweenLite(this._textContainer, 0.1, {delay : 0.1, alpha : 1}),
            new TweenLite(this._textContainer, 0.5, {delay : 0.1, rotation : 0}),
            new TweenLite(this._megaWinRadialText.scale, 0.1, {delay : 0.1, x : 1}),
        ]);

        //particles
        tl.add(this.getParticleAnimation(countDuration, 4), 0);

        //counter
        tl.add(TweenLite.fromTo(this, countDuration,
            {currentDisplayAmount : countFromTo[0]},
            {
                currentDisplayAmount : countFromTo[1], onUpdate : () => this.updateWinText(), ease : "power2.out"
            })
            , 0);
        tl.add(() =>this.centerWinText());

        if(transition) {
            let transition:TimelineLite = this.createTransitionTwoThree();
            tl.add(transition, tl.totalDuration() - transition.totalDuration());
        }
        return tl;
    }

    private createTransitionTwoThree():TimelineLite {
        let tl:TimelineLite = new TimelineLite();
        //Text out
        tl.add(() => this.flipAnchorOnText(this._megaWinRadialText));
        tl.add([
            new TweenLite(this._textContainer, 0.5, {rotation : 0.06, ease : "back.in"}),
            new TweenLite(this._textContainer, 0.1, {alpha : 0, delay : 0.4}),
            new TweenLite(this._megaWinRadialText.scale, 0.1, {x : 0, delay : 0.4})
        ]);


        //Reset text continer
        tl.add([
            new TweenLite(this._textContainer, 0.01, {alpha : 0}),
            new TweenLite(this._textContainer, 0.01, {rotation : -0.06})
        ]);

        tl.add([
            this._nextLevelMC.getAnimation([0, 8]),
            new TweenLite(this._bannerContainer.scale, 0.21, {x : 1.3, y : 1.3, ease : "power3.out"}),
            () => this._nextLevelMC.show(),
            () => this._introMC.hide()
        ]);
        return tl;
    }

    private createLevelThreeIn(countDuration:number, countFromTo:[number, number], transition:boolean):TimelineLite {
        let tl:TimelineLite = new TimelineLite();
        tl.add([
            this._nextLevelMC.getAnimation([8, this._nextLevelMC.totalFrames]),
            new TweenLite(this._bannerContainer.scale, 0.1, {x : 1.0, y : 1.0, ease : "back.out(3)"}),
            new TweenLite(this._textContainer, 0.1, {delay : 0.1, alpha : 1}),
            new TweenLite(this._textContainer, 0.5, {delay : 0.1, rotation : 0}),
            new TweenLite(this._superMegaWinRadialText.scale, 0.1, {delay : 0.1, x : 1}),
            () => this.centerWinText()
        ]);

        //particles
        tl.add(this.getParticleAnimation(countDuration, 6), 0);

        //counter
        tl.add(TweenLite.fromTo(this, countDuration,
            {currentDisplayAmount : countFromTo[0]},
            {
                currentDisplayAmount : countFromTo[1], onUpdate : () => this.updateWinText(), ease : "power2.out"
            })
            , 0);

        return tl;
    }

    private updateWinText() {
        let newString = KitchenDramaSushiMania.apiPlugin.currency.formatValue(this.currentDisplayAmount);
        if(newString.length != this._winAmount.text.length) {
            this._winAmount.text = newString;
            this._winAmount.position.set(this._stageWidth / 2 - this._winAmount.textWidth / 2, 475);

            this._winAmount.updateTransform();

        } else {
            this._winAmount.text = newString
        }

    }

    private centerWinText() {
        this._winAmount.position.set(this._stageWidth / 2 - this._winAmount.textWidth / 2, 475);
    }

    private createWinAmountText() {
        this._winAmount = new PIXI.BitmapText(KitchenDramaSushiMania.apiPlugin.currency.formatValue(0), this._amountTextStyle);
        this._winAmount.position.set(this._stageWidth / 2 - this._winAmount.textWidth / 2, 475);
        this._winAmount.alpha = 1;
        this._winAmount.scale.set(1, 1);

    }

    private getParticleAnimation(countDuration:number, maxParticles:number):TimelineLite {
        let tl:TimelineLite = new TimelineLite();


        for(let i:number = 0; i < this._leftParticles.length; i++) {
            let leftParticle = this._leftParticles[i];
            let leftParticleAnimation = leftParticle.createTween("slow(0.3, 0.8, false)");
            leftParticleAnimation.totalDuration(countDuration - 0.7);

            let rightParticle = this._rightParticles[i];
            let rightParticleAnimation = rightParticle.createTween("slow(0.3, 0.8, false)");
            rightParticleAnimation.totalDuration(countDuration - 0.7);



            tl.add(() => {leftParticle.emitter.maxParticles = maxParticles}, 0);
            tl.add(() => {rightParticle.emitter.maxParticles = maxParticles}, 0);
            tl.add(leftParticleAnimation, 0);
            tl.add(rightParticleAnimation, 0);
        }


        return tl;
    }
}